import Component from "@ember/component"
import { computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import { isCachedMembershipActive } from "cc-frontend/utils/group"
import _ from "lodash"

export default class AdminDetailUser extends Component {
  @service("ember-store") store

  @computed("modelToStringify.attributes.cachedMemberships.length")
  get schoolDistrictGroupIds() {
    return _.chain(get(this, "modelToStringify.attributes.cachedMemberships"))
      .filter(isCachedMembershipActive)
      .filter(
        (membership) => membership.usedAs === "school" || membership.usedAs === "school-network"
      )
      .map((membership) => membership.groupId)
      .value()
  }

  @computed("modelToStringify.attributes.cachedMemberships.length")
  get lockedPendingSchoolDistrictGroupIds() {
    // Other memberships that show up on the user's home page:
    // - Open requested groups
    // - Open potential groups
    // - Locked accepted, requested, or potential groups
    return _.chain(get(this, "modelToStringify.attributes.cachedMemberships"))
      .filter(
        (membership) =>
          !membership.isAncestor &&
          (membership.usedAs === "school" || membership.usedAs === "school-network")
      )
      .filter(
        (membership) =>
          (membership.state === "open" &&
            (membership.membershipType === "group-membership-requested" ||
              membership.membershipType === "group-membership-potential")) ||
          (membership.state === "locked" &&
            (membership.membershipType === "group-membership-accepted" ||
              membership.membershipType === "group-membership-requested" ||
              membership.membershipType === "group-membership-potential"))
      )
      .map((membership) => membership.groupId)
      .value()
  }

  @computed("modelToStringify.attributes.subscriptions")
  get subscriptions() {
    return _.chain(get(this, "modelToStringify.attributes.subscriptions"))
      .sortBy("startedAt")
      .value()
  }
}
